import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface State {
    showSheet?: boolean;
    renaming?: boolean;
    mintingFailed?: boolean;
    mintingInitiated?: boolean;
    mintingSuccess?: boolean;
}

interface Actions {
    toggleShow: () => void;
    // TODO move this/ make this store more specific to the flow?
    setMintingFailed: (mintingFailed: boolean) => void;
    setMintingInitiated: (mintingInitiated: boolean) => void;
    setMintingSuccessOptimistic: (mintingSuccess: boolean) => void;
    setRenaming: (renaming: boolean) => void;
    reset: () => void;
}
type MintingOverlayStoreState = State & Actions;

const initialState: State = {
    showSheet: false,
    renaming: false,
    mintingFailed: false,
    mintingInitiated: false,
    mintingSuccess: false,
};

export const useMintingOverlayStore = create<MintingOverlayStoreState>()(
    devtools(
        (set) => ({
            ...initialState,
            toggleShow: () => {
                set((state) => {
                    if (state.showSheet && !state.mintingInitiated) {
                        state.reset();
                    }
                    return { showSheet: !state.showSheet };
                });
            },
            setMintingFailed: (mintingFailed) => set({ mintingFailed, mintingInitiated: false }),
            setMintingSuccessOptimistic: (mintingSuccess) => set({ mintingSuccess }),
            setMintingInitiated: (mintingInitiated) => set({ mintingInitiated }),
            setRenaming: (renaming) => set({ renaming }),
            reset: () => set(initialState),
        }),
        { name: 'minting-overlays-store' },
    ),
);
